/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */

export type LabOrderDtoInterpretation = (typeof LabOrderDtoInterpretation)[keyof typeof LabOrderDtoInterpretation];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LabOrderDtoInterpretation = {
  POSITIVE: 'POSITIVE',
  NEGATIVE: 'NEGATIVE',
  INDETERMINATE: 'INDETERMINATE',
  NOT_EXECUTED: 'NOT_EXECUTED',
  PENDING: 'PENDING',
  NONE: 'NONE',
} as const;
